import type { EventFormValues } from "gsintegrations";

export const isTerreiroAddressConfigured = (
  address?: Partial<EventFormValues["location"]> | null,
) => {
  if (!address) return false;

  const requiredFields = [
    address.street,
    address.number,
    address.neighborhood,
    address.city,
    address.state,
  ];

  return requiredFields.every(
    (field) => typeof field === "string" && field.trim().length > 0,
  );
};

export const mapTerreiroAddressToEventAddress = (
  address?: Partial<EventFormValues["location"]> | null,
) => ({
  zipCode: address?.zipCode ?? "",
  street: address?.street ?? "",
  number: address?.number ?? "",
  complement: address?.complement ?? "",
  neighborhood: address?.neighborhood ?? "",
  city: address?.city ?? "",
  state: address?.state ?? "",
  reference: address?.reference ?? "",
});
